import { createSlice } from "@reduxjs/toolkit";

export const AdditionalInfoSlice = createSlice({
  name: "AdditionalInfo",
  initialState: {
    Loading: false,
    AdditionalInfoData: {},
    UpdateResponse: "",
  },
  reducers: {
    SetAdditionalInfoLoading: (state, action) => {
      state.Loading = action.payload;
    },
    GetAdditionalInfo: (data) => {
      return data;
    },
    SetAdditionalInfo: (state, action) => {
      state.AdditionalInfoData = action.payload;
    },
    UpdateAdditionalInfo: (data) => {
      return data;
    },
    SetUpdateAdditionalInfoResponse: (state, action) => {
      state.UpdateResponse = action.payload;
    },
  },
});

export const {
  SetAdditionalInfoLoading,
  GetAdditionalInfo,
  SetAdditionalInfo,
  UpdateAdditionalInfo,
  SetUpdateAdditionalInfoResponse,
} = AdditionalInfoSlice.actions;

export default AdditionalInfoSlice.reducer;
